import React, { useCallback, useState } from 'react';
import RowV2 from '@/components/v2/RowV2';
import getDateTimeAgo from '@/lib/getDateTimeAgo';
import Button from '../../Button.jsx';

const AutosaveListRow = ({ autosave, onRestore, handleClose }) => {
  const [isRestoring, setIsRestoring] = useState(false);

  const handleRestore = useCallback(async () => {
    if (!onRestore) {
      return;
    }
    setIsRestoring(true);
    try {
      await onRestore(autosave);
      handleClose();
    } finally {
      setIsRestoring(false);
    }
  }, [autosave, onRestore, handleClose]);

  return (
    <div className="autosave-list-row">
      <span className="autosave-created-on">
        <span className="time">{getDateTimeAgo(autosave?.createdOn)} ago</span>
      </span>
      <RowV2 className="borderless" style={{ height: 24 }}>
        <RowV2.Left>
          <Button size={'sm'} onClick={handleRestore} className={'link slim'} disabled={isRestoring} loading={isRestoring} title="Restore this autosave to the draft editor">
            Restore
          </Button>
        </RowV2.Left>
      </RowV2>
    </div>
  );
};

export default AutosaveListRow;
